(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page-v2"]) return;
  try {
    
const accordionBtns = document.querySelectorAll(".ds_accordion");

        function toggleAccordion(el) {
            el.classList.toggle("is-open");
            let content = el.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }

        accordionBtns.forEach((accordion) => {
            accordion.setAttribute("role", "button");
            accordion.setAttribute("tabindex", "0");
            accordion.onclick = function () {
                toggleAccordion(this);
            };
            accordion.onkeydown = function (e) {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleAccordion(this);
                }
            };
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"]) return;
  try {
    
const accordionBtns = document.querySelectorAll(".ds_accordion");

        function toggleAccordion(el) {
            el.classList.toggle("is-open");
            let content = el.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }

        accordionBtns.forEach((accordion) => {
            accordion.setAttribute("role", "button");
            accordion.setAttribute("tabindex", "0");
            accordion.onclick = function () {
                toggleAccordion(this);
            };
            accordion.onkeydown = function (e) {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleAccordion(this);
                }
            };
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-prep-care-template"]) return;
  try {
    
const accordionBtns = document.querySelectorAll(".ds_accordion");

        accordionBtns.forEach((accordion) => {
        accordion.onclick = function () {
            this.classList.toggle("is-open");

            let content = this.nextElementSibling;


            if (content.style.maxHeight) {
            //this is if the accordion is open
            content.style.maxHeight = null;
            } else {
            //if the accordion is currently closed
            content.style.maxHeight = content.scrollHeight + "px";
            console.log(content.style.maxHeight);
            }
        };
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    var recommended_url = productRecommendationsSection.dataset.baseUrl;
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
